import { Controller } from "@hotwired/stimulus";
import { hideModal, removeBackdrop, showModal } from "../ui/bootstrap_ui";
import { refreshMenu } from "../util/menu";

// Opens a Bootstrap modal that a Turbo Stream appended to the page and removes
// it again once it is closed (the modal behavior itself is in ui/bootstrap_ui).
// With a menu URL the navigation menu is re-rendered after the modal is gone,
// e.g. for the badge of unread messages.
export default class extends Controller {
  static values = {menuUrl: String};

  connect() {
    this.element.addEventListener("modal:hidden", this.remove);
    showModal(this.element);
  }

  disconnect() {
    this.element.removeEventListener("modal:hidden", this.remove);
    // Removed while still open (e.g. by a Turbo Stream): no transition to wait for.
    this.element.classList.remove("in");
    removeBackdrop(this.element);
    if (this.hasMenuUrlValue) refreshMenu(this.menuUrlValue);
  }

  close() {
    hideModal(this.element);
  }

  remove = () => {
    this.element.remove();
  };
}
